import { defineComponent as _defineComponent } from 'vue'
import { getEmployeesOffersV2, getPrivateRatesWithoutBff } from "@/api/offers";
import { getOneAdvertiser } from "@/api/revenue";
import { getAffiliateSearch } from "@/api/user";
import BaseAutocomplete from "@/components-UI/BaseAutocomplete.vue";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import BaseSelect from "@/components-UI/BaseSelect.vue";
import BaseSwitch from "@/components-UI/BaseSwitch.vue";
import BaseTranslateCountry from "@/components-UI/BaseTranslateCountry.vue";
import BaseList from "@/components-UI/list/BaseList.vue";
import BaseListItem from "@/components-UI/list/BaseListItem.vue";
import AffiliateIsMarked from "@/components/affiliate/AffiliateIsMarked.vue";
import { OFFER_TYPE_MARKING } from "@/mappings/offer";
import { usePrivateRatesStore } from "@/store_v3/PrivateRatesStore";
import { showServerError } from "@/utils";
import { translateBoolean } from "@/utils/translate";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePrivateRateHead',
  emits: ['update-table'],
  setup(__props, { emit }) {

const {
    createForm,
    getOfferTags,
    isIncludeDepartment,
    isOfferTrafficAPI,
    changedGoals,
} = storeToRefs(usePrivateRatesStore());


const isLoading = ref(false);
const markingTypeItems = [
    { text: 'Сверху', value: 'above' },
    { text: 'Из ставки', value: 'from_rate' },
    { text: 'Всегда из ставки', value: 'from_rate_always' },
    { text: 'Не учитывать', value: 'none' },
];
const autocompleteOfferField = ref({
    emptyText: 'Оффер не найден',
    apiMethod: getEmployeesOffersV2,
    itemValue: 'legacy_id',
    template: (item) => `${item.legacy_id} ${item.name}`,
    placeholder: 'Выберите оффер',
    triggerOnMounted: true,
    externalParams: {
        fields: 'legacy_id,name,goals,tags,currency,departments,manager,advertiser,traffics',
    },
});

const autocompleteAffiliateField = computed(() => {
    return {
        emptyText: 'Партнёр не найден',
        apiMethod: getAffiliateSearch,
        itemValue: 'id',
        template: (item) => `${item.id} ${item.first_name} ${item.last_name}`,
        placeholder: 'Выберите партнёра',
        triggerOnMounted: true,
        disabled: createForm.value?.defaultRate,
    };
});

const setMarkingType = (value) => {
    createForm.value.type = value;
};

const selectOffer = ({ item }) => {
    changedGoals.value = [];
    const advertiserId = item.advertiser.legacy_id;
    getAdvertiser(advertiserId);
    createForm.value.offerObj = item;
    const { AlwaysFromRate, FromRate, Above } = OFFER_TYPE_MARKING;

    if (createForm.value.affiliateId || createForm.value.defaultRate) {
        getActiveRates();
    }

    if (isIncludeDepartment.value || isOfferTrafficAPI.value) {
        createForm.value.type = 'none';
        return;
    }

    if (getOfferTags.value.includes(Above)) {
        createForm.value.type = 'above';
    } else if (getOfferTags.value.includes(FromRate)) {
        createForm.value.type = 'from_rate';
    }  else if (getOfferTags.value.includes(AlwaysFromRate)) {
        createForm.value.type = 'from_rate_always';
    } else {
        createForm.value.type = null;
    }
};

const updateDefaultRate = (value) => {
    createForm.value.defaultRate = value;
    (value && createForm.value.offerId) && getActiveRates();
    changedGoals.value = [];
};

const selectAffiliate = ({ item }) => {
    createForm.value.affiliateObj = item;
    changedGoals.value = [];
    getActiveRates();
};

const getActiveRates = async () => {
    try {
        if (!createForm.value.offerId) return;
        isLoading.value = true;
        const params = getParams();
        const { data } = await getPrivateRatesWithoutBff(params);
        createForm.value.activeRates = data;
        emit('update-table');
    } catch (e) {
        showServerError(e, 'Не удалось получить ставки');
    } finally {
        isLoading.value = false;
    }
};

const getParams = () => {
    const params = {
        offer_id: createForm.value.offerId,
        rate_status: ['active'],
    };
    if (createForm.value.defaultRate) {
        params.is_default = true;
    } else if (createForm.value.affiliateId) {
        params.affiliate_id = [createForm.value.affiliateId];
    }
    return params;
};

const getAdvertiser = async (id) => {
    try {
        createForm.value.advertiserObj = await getOneAdvertiser(id);
    } catch (err) {
        showServerError(err, 'Не удалось получить рекламодателя');
    }
};

watch(() => createForm.value.defaultRate, (value: boolean) => {
    if (value) {
        createForm.value.affiliateId = null;
        createForm.value.affiliateObj = null;
    }
}, { deep: true });

return { __sfc: true,createForm, getOfferTags, isIncludeDepartment, isOfferTrafficAPI, changedGoals, emit, isLoading, markingTypeItems, autocompleteOfferField, autocompleteAffiliateField, setMarkingType, selectOffer, updateDefaultRate, selectAffiliate, getActiveRates, getParams, getAdvertiser, BaseAutocomplete, BaseEditableCard, BaseSelect, BaseSwitch, BaseTranslateCountry, BaseList, BaseListItem, AffiliateIsMarked, translateBoolean }
}

})